<style lang="less">
</style>
<template>
  <span :class="classString">
    <el-upload
      :action="action"
      :data="params"
      :accept="accept"
      :headers="headers"
      :show-file-list="false"
      :on-success="handleSuccess"
      :on-error="handleError"
    >
      <slot></slot>
    </el-upload>
  </span>
</template>

<script>

import store from '@/store'

export default {
  props: {
    target: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => ({})
    },
    accept: {
      type: String,
      default: ""
    },
    classString: {
      type: String,
      default: ''
    }
  },
  mounted() {
  },
  computed: {
    action() {
      const baseUrl = this.$config.api.baseURL
      return `${baseUrl}/${this.target}`
    },
    headers() {
      const { token } = store.state.auth
      return {
        'Authorization': `Bearer ${token}`
      }
    }
  },
  methods: {
    handleSuccess(res, file) {
      this.$emit('success', res.data, file)
    },
    handleError(error) {
      this.$emit('error', JSON.parse(error.message))
    },
  }
}
</script>
